import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function uploadFile(formData) {
  try {
    const response = await axios.post(`${apiBaseUrl}invoice/file_upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createWebsitePlan error:", error);
    return { status: false, type: "danger", success: "Failed to save plan" };
  }
}

export async function createInvoice(main_type, invoiceData) {
  try {
    const encodedData = btoa(JSON.stringify(invoiceData));
    const fd = new FormData();
    fd.append("invoice_data", encodedData);
    fd.append("main_type", main_type);

    const response = await axios.post(`${apiBaseUrl}invoice/create_invoice`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createInvoice error:", error);
    return { status: false, type: "danger", success: "Failed to save record" };
  }
}

// 🔹 Get All Records (Paginated + Filtered)
export async function getInvoices(
  main_type,
  created_by = "",
  page_no = 0,
  status = "",
  pay_status = "",
  search_key = ""
) {
  try {
    const fd = new FormData();
    fd.append("main_type", main_type);
    fd.append("page_no", page_no);

    // Column names depend on main_type (server handles mapping automatically)
    fd.append("invoice_created_by", created_by);
    fd.append("invoice_status", status);
    fd.append("invoice_pay_status", pay_status);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}invoice/get_invoices`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getInvoices error:", error);
    return { status: false, type: "danger", success: "Failed to load records" };
  }
}

// 🔹 Delete Invoice / Estimate / PO / Credit Memo
export async function deleteInvoice(main_type, idField, idValue) {
  try {
    const fd = new FormData();
    fd.append("main_type", main_type);
    fd.append(idField, idValue);

    const response = await axios.post(`${apiBaseUrl}invoice/delete_invoice`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteInvoice error:", error);
    return { status: false, type: "danger", success: "Failed to delete record" };
  }
}

// 🔹 Update Document Status
export async function updateInvoiceStatus(main_type, idField, idValue, statusField, statusValue) {
  try {
    const fd = new FormData();
    fd.append("main_type", main_type);
    fd.append(idField, idValue);
    fd.append(statusField, statusValue);

    const response = await axios.post(`${apiBaseUrl}invoice/update_invoice_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateInvoiceStatus error:", error);
    return { status: false, type: "danger", success: "Failed to update status" };
  }
}

// 🔹 Update Invoice Payment Status (Invoices Only)
export async function updateInvoicePaymentStatus(invoice_id, invoice_pay_status) {
  try {
    const fd = new FormData();
    fd.append("main_type", "invoice");
    fd.append("invoice_id", invoice_id);
    fd.append("invoice_pay_status", invoice_pay_status);

    const response = await axios.post(`${apiBaseUrl}invoice/update_invoice_payment_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateInvoicePaymentStatus error:", error);
    return { status: false, type: "danger", success: "Payment status update failed" };
  }
}

// 🔹 Get Invoice Summary Report
export async function getInvoiceReport(main_type, created_by = "") {
  try {
    const fd = new FormData();
    fd.append("main_type", main_type);
    fd.append("invoice_created_by", created_by);

    const response = await axios.post(`${apiBaseUrl}invoice/get_invoice_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getInvoiceReport error:", error);
    return { status: false, type: "danger", success: "Failed to load report" };
  }
}

export async function getTableRowCount(main_type) {
  try {
    const fd = new FormData();
    fd.append("main_type", main_type);

    const response = await axios.post(
      `${apiBaseUrl}invoice/get_table_row_count`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("getTableRowCount error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch table row count",
    };
  }
}

export async function getInvoiceById(main_type, record_id) {
  try {
    const fd = new FormData();
    fd.append("main_type", main_type);
    fd.append("record_id", record_id);

    const response = await axios.post(`${apiBaseUrl}invoice/get_invoice_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getInvoiceById error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch document details",
    };
  }
}

